/**
 * Example for a version update where bulk, bulktank and voyagelog had massive changes in attributes
 * (Remeber this was before the VoyageBulk model object).
 */

VRC.Version131 = (function(){

	var types = {
		bulk : 'bulk',
		voyageLog : 'voyageLog'
	};

	var mapVoyageBulk = function(old){

		return {
			voyageBulkId : old.id,
			bulkTankId : old.bulk_id,
			bulkTypeId : old.type,
			itemDescription : old.definition,
			valueQty : old.qty,
			qtyRob : old.qty_rob,
			valueUnit : old.unit,
			sg : old.sg,
			dgInfo : old.dangerous,
			remarks : old.remarks,
			action : old.action,
			date : old.date,
			companyId : old.company,
			originId : old.origin,
			destinationId : old.destination
		}
	};

	var upgradeBulkTank = function(bulkTank){
		var data = VRC.BulkState.mapOldFormatToNewFormat(bulkTank.data);
		var bulkTankObject = VRC.BulkTank(data);

		_.each(bulkTank.content, function(voyageBulk){
			var voyageBulkJson = mapVoyageBulk(voyageBulk, bulkTankObject.getBulkTankId());
			var newVB = VRC.VoyageBulk(voyageBulkJson);
			bulkTankObject.addContent(newVB);

		});

		return bulkTankObject.toJson();
	};

	var isUpgraded = function(data, type){
		var isUpgraded = true;
		if(type === types.bulk){
			isUpgraded = data.bulkTanks !== undefined;
		}
		else if(type === types.voyageLog){
			if(data.length > 0){
				isUpgraded = !_.isArray(data[0]);
			}
		}

		return isUpgraded;
	};


	var upgradeBulk = function(data){

		var formattedData = {bulkTanks : []};

		_.each(data, function(bulkTank){
			formattedData.bulkTanks.push(upgradeBulkTank(bulkTank));
		});

		return formattedData;
	};


	var upgradeVoyageLog = function(array){
		var vl = VRC.VoyageLogEntry();
		vl.fromArray(array);

		return vl.toJson();
	};

	var upgradeVoyageLogs = function(data){

		var formattedData = [];
		_.each(data, function(voyageLog){
			formattedData.push(upgradeVoyageLog(voyageLog));
		});

		return formattedData;
	};


	var upgrade = function(json, type){
		var returnValue;
		if(type === types.bulk){
			returnValue = upgradeBulk(json)
		}
		if(type === types.voyageLog){
			returnValue = upgradeVoyageLogs(json)
		}
		return returnValue;

	};

	return {
		upgrade : upgrade,
		isUpgraded : isUpgraded
	};
})();
